import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INVENTORY_FIRM_ORDER_BASE_PATH } from '../../../../../../../../../features/inventory/firm-order/inventory-firm-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'inventory-firm-order-list',
        label: 'Inventory',
        to: INVENTORY_FIRM_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
